import React, { useEffect, useRef, useState } from 'react';
import { Segmented } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { FlexWrapper } from '../../theme/common_style';
import BasicInfo from '../employees/view-employee/components/BasicInfo';
import GeneralInfo from '../employees/view-employee/components/GeneralInfo';
import EmployeeDocuments from '../employees/view-employee/components/EmployeeDocuments';
import SalaryInfo from '../employees/view-employee/components/SalaryInfo';
import Remarks from '../employees/view-employee/components/Remarks';
import { viewEmployeeApi } from '../../redux/employee/apiRoute';
import { updateActiveTab } from '../../redux/employee/EmployeeSlice';
import EmployeeLeaves from '../employees/EmployeeLeaves';
import { useLocation, useNavigate } from 'react-router-dom';

const MyProfile = () => {
  const activeTab = useSelector((state) => state?.employeeSlice?.activeTab);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(null);
  const location = useLocation();
  const { id } = location.state || {};

  const wrapperRef = useRef(null);
  const navigate = useNavigate();

  const handleGetEmployeeDetails = async () => {
    try {
      setLoading(true);
      let res = await viewEmployeeApi(id);
      if (res?.statusCode === 200) {
        setDetails(res?.data);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) {
      navigate('/dashboard', { replace: true });
    } else {
      handleGetEmployeeDetails();
      wrapperRef.current?.scrollIntoView();
    }
  }, [id]);

  return (
    <div ref={wrapperRef}>
      <FlexWrapper justify="start" style={{ marginTop: '20px' }}>
        <Segmented
          prefixCls="antCustomSegmented"
          value={activeTab}
          options={['General Info', 'Documents', 'Salary', 'Leaves', 'Remarks']}
          onChange={(value) => {
            dispatch(updateActiveTab(value));
          }}
          className="responsive-segmented"
        />
      </FlexWrapper>
      {id && (
        <>
          {activeTab === 'General Info' && <BasicInfo loading={loading} details={details} />}
          {activeTab === 'General Info' && (
            <GeneralInfo
              loading={loading}
              details={details}
              handleList={handleGetEmployeeDetails}
            />
          )}
          {activeTab === 'Documents' && <EmployeeDocuments />}
          {activeTab === 'Salary' && <SalaryInfo />}
          {activeTab === 'Remarks' && <Remarks />}
          {activeTab === 'Leaves' && <EmployeeLeaves />}
        </>
      )}
    </div>
  );
};

export default MyProfile;
